enum Main {
  SLIDERS,
  RAILS,
}

export default Main;
